import {
  helperGetStaticContentUrl,
  helperGetRelativeUrl,
  helperGetVideoUrl,
} from 'helpers/RouteHelper';
import { formatAiredDate } from 'helpers/VideoHelper';
import { onResultClick } from 'screens/Find/components/FindProcessor';
import getBadge from '../helpers/ProcessorHelper';

const EpisodeProcessor = ({ item, account, searchProps }) => {
  const title = item?.name ?? '';
  const image =
    item?.images?.videoList?.raw ??
    helperGetStaticContentUrl('images', 'FallBack-FOXNATION-min.jpg');
  const altText = item?.images?.videoList?.altText ?? '';
  const description = item?.description ?? '';
  const subtitle = item?.seriesName ?? '';
  const originalAirDate = item?.originalAirDate ?? '';
  const datePublished = item?.datePublished ?? '';
  const available = item?.available ?? '';
  const airedDate = formatAiredDate(originalAirDate || datePublished || available, '', 'MM-DD-YY');
  const url = item?.playerScreenUrl ?? '';
  const videoId = item?.videoId ?? '';
  const link = url ? helperGetRelativeUrl({ url }) : helperGetVideoUrl(videoId);

  return {
    title,
    image,
    altText,
    description,
    subtitle,
    airedDate,
    link,
    badgeProps: getBadge(item),
    onClick: () =>
      onResultClick({
        account,
        item,
        searchProps,
        titleText: title,
      }),
  };
};

const TileProcessor = ({ item, account, searchProps }) => {
  const image = item?.images?.seriesList?.raw;
  const altText = item?.images?.seriesList?.altText;
  const titleText = item?.name;
  const link = `/${item?.id}`;
  const title = `${item?.name}`;
  const episodeCount = item?.fullEpisodeCount;

  return {
    image,
    altText,
    titleText,
    link,
    title,
    episodeCount,
    onClick: () =>
      onResultClick({
        account,
        item,
        searchProps,
        titleText,
      }),
  };
};

export { EpisodeProcessor, TileProcessor };
